<div class="notifaction-modal">
  <div class="flex justify-between items-center p-4 modal-header">
    <h3>{{title}}</h3>
    <lib-btn-close [buttonType]="'notifaction-modal-exit'"></lib-btn-close>
  </div>

  <div class="modal-content">
    <div class="w-full flex justify-between mb-5">
      <div class="p-4">
        <mat-checkbox
          (change)="toggleAll($event.checked)">
        </mat-checkbox>
      </div>
      <div class="p-4">
        <lib-button [cssType]="'btn-dropdown'"  [menuItems]="menuItems" [text]="'Organize Notifications'" [icon]="'downcaret'" (mainClick)="export()"></lib-button>
      </div>
    </div>




    @for(notification of notifications; track notification) {
      <div class="notifaction-item flex p-4">
        <div>
          <mat-checkbox 
            [checked]="notification.checked"
            (change)="updateSelectAll()">
          </mat-checkbox>
        </div>
        <div class="flex flex-col w-full ml-3">
          <div class="flex w-full justify-between">
              <p class="large bold">{{notification.title}}</p>
              <div>
                <p class="small timeago">{{formatAge(notification.age)}}</p>
                <span class="status"></span>   
              </div>
          </div>
          <div class="flex w-full">
              <p [innerHTML]="notification.message"></p>
          </div>

        </div>
      </div>
    }
  </div>
</div>